<template>
    <div class="mailing_tableWrapper relative">
        <div class="search_loading" v-if="!isMailingLoad">
            <loading></loading>
        </div>
        <ul v-if="isMailingLoad" class="mailing_table">
            <li class="mailing_column_header" v-for="(tableHeader, index) in table_header" :key="index">
                {{tableHeader.title}}
            </li>
            <template v-for="(item, itemIndex) in mailings">
                <template v-for="(value, key) in item">
                    <li v-if="key === 'mailingName'" class="mailing_column mailing_column_title" :key="`${itemIndex}-${key}`" :class="{ 'showAll': buttonStates[item.id]}">
                        <p>
                            {{ value }}
                        </p>
                    </li>
                    <li v-if="key === 'selectedProducts'" class="mailing_columnText" :key="`${itemIndex}-${key}`" :class="{ 'showAll': buttonStates[item.id]}">
                        <p class="mailing_column_text" v-for="(products, keyProduct) in value" :key="`${keyProduct}-keyProduct`">
                            {{ products }}
                            <span v-if="value.length - 1 !== keyProduct">,</span>
                        </p>
                    </li>
                    <li v-if="key === 'emails'" class="mailing_columnText" :key="`${itemIndex}-${key}`" :class="{ 'showAll': buttonStates[item.id]}">
                        <p class="mailing_column_text" v-for="(emails, keyEmail) in value" :key="`${keyEmail}-keyEmail`">
                            {{ emails }}
                            <span v-if="value.length - 1 !== keyEmail">,</span>
                        </p>
                    </li>
                    <li v-if="key === 'isActive'" class="mailing_column" :key="`${itemIndex}-${key}`" :class="{ 'showAll': buttonStates[item.id]}">
                        <div
                            class="mailing_actions"
                        >
                            <label :for="`mailing_switcher-${itemIndex}`" class="mailing_switch">
                                <input :id="`mailing_switcher-${itemIndex}`" type="checkbox" :checked="value"  @click="() => toggleCheckbox(item.id)">
                                <div class="mailing_slider mailing_round"></div>
                            </label>
                            <button
                                class="mailing_edits_button"
                                @click="mailingStore.editMailing(item.id)"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22.000000" height="22.000000" viewBox="0 0 22 22" fill="none">
                                    <path id="Shape" d="M0 17.3556L0 22L4.64441 22L18.0889 8.43333L13.4445 3.78889L0 17.3556ZM21.6333 4.88889C22.1222 4.39999 22.1222 3.66667 21.6333 3.17778L18.8223 0.366669C18.3334 -0.122223 17.6 -0.122223 17.1111 0.366669L14.9111 2.56667L19.5555 7.21111L21.6333 4.88889Z" fill="#174A8B" fill-opacity="1.000000" fill-rule="evenodd"/>
                                </svg>
                            </button>
                            <button class="btn-reset btn_chevron" @click="toggleChevron(item.id)">
                                <svg class="btn_chevron" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="#174A8B" :style="{ transform: buttonStates[item.id] ? 'rotate(180deg)' : 'rotate(0deg)' }">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 15.75 7.5-7.5 7.5 7.5" />
                                </svg>
                            </button>
                        </div>
                    </li>
                </template>
            </template>
        </ul>
        <div
            v-if="mailings.length >= 20"
            class="mailing_buttonWrapper"
        >
            <button class="mailing_button">Добавить новую рассылку</button>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import loading from "@/components/support/loading";
import { products } from "@/entities/Mailing/config/mailing.js";
import { generateMap } from '@/utils/generateMap.js';
import { useMailingStore } from "@/stores/MailingStore";

export default {
    name: "CurrentMailingsTable",
    components: {
        loading,
    },
    setup() {
        const mailingStore = useMailingStore();
        return {
            mailingStore
        }
    },
    data: function () {

        const data =  {
            table_header: [
                {title: 'Название рассылки', sortable: true},
                {title: 'Типы товаров', sortable: false},
                {title: 'Адреса', sortable: true},
                {title: 'Действия', sortable: false},
            ],
            isMailingLoad: false,
            buttonStates: {},
            mailings: [],
        }

        axios.get('/api/b2b_user/subscribe')
            .then((response) => {
                data.isMailingLoad = false;
                const resp = response.data;

                if (typeof (resp.success) !== "undefined" && (resp.success === true)) {
                    data.mailings = this.normalizeProducts(resp.items);
                    data.isMailingLoad = true;
                }

                if (typeof (resp.error) !== "undefined" && (resp.error === true)) {

                    this.$notifyError(resp.message);
                }


            })
            .catch((error) => {
                console.log(error);
                this.$notifyError('Неизвестная ошибка, попробуйте вновь или обратитесь к менеджеру');
            });


        return data;

        
    },
    methods: {
        toggleCheckbox(id) {
            let send_data = {};
            axios.get(`/api/b2b_user/subscribe/${id}`)
                .then((response) => {
                    const resp = response.data;
                    if (typeof (resp.success) !== "undefined" && (resp.success === true)) {
                        const currentMailing = resp.item;
                        send_data.mailingName = currentMailing.mailingName;
                        send_data.isActive = !currentMailing.isActive;
                        send_data.emails = currentMailing.emails;
                        send_data.mailingPeriods = currentMailing.mailingPeriods;
                        send_data.selectedFormats = currentMailing.selectedFormats;
                        send_data.selectedStorageCities = currentMailing.selectedStorageCities;
                        send_data.selectedProducts = currentMailing.selectedProducts;
                        send_data.sortOrder = currentMailing.sortOrder;
                        send_data.filterByFields = currentMailing.filterByFields;
                        send_data.sortedByFields = currentMailing.sortedByFields;
                        send_data.selectedByField = currentMailing.selectedByField;
                        send_data.selectedBySortedField = currentMailing.selectedBySortedField;
                    }
                    if (typeof (resp.error) !== "undefined" && (resp.error === true)) {
                        this.$notifyError(resp.message);
                    }


                })
                .then(() => {
                    axios.put(`/api/b2b_user/subscribe/${id}`, send_data)
                        .then((response) => {

                            let resp = response.data;

                            if (typeof (resp.success) !== "undefined" && (resp.success === true)) {
                                this.$notifySuccess(resp.message);
                            }

                            if (typeof (resp.error) !== "undefined" && (resp.error === true)) {
                                this.$notifyError(resp.message);
                            }
                            if (typeof (resp.notice) === 'object') {
                                for (const index in resp.notice) {
                                    if (typeof (resp.notice[index].message) != 'undefined') {
                                        this.$notifyWarning(resp.notice[index].message);
                                    }
                                }
                            }

                        })
                        .catch((error) => {
                            console.log(error);
                            this.$notifyError('Неизвестная ошибка, попробуйте вновь или обратитесь к менеджеру');
                        });
                })
                .catch((error) => {
                    console.log(error);
                    this.$notifyError('Неизвестная ошибка, попробуйте вновь или обратитесь к менеджеру');
                });
            
            this.mailings.find((el, index, arr) => {
                el.id === id ? arr[index].isActive = !arr[index].isActive : null
            });
        },
        normalizeProducts(mailings) {
            const productsMap = generateMap(products);
            return mailings.map((mailing) => {
                const normalizeSelectedProducts = mailing.selectedProducts.map((product) => {
                    return productsMap.get(product);
                });

                return {
                    ...mailing,
                    selectedProducts: normalizeSelectedProducts
                };
            });
        },
        toggleChevron(id) {
            if (this.buttonStates[id]) {
            this.$set(this.buttonStates, id, false);
            } else {
                this.$set(this.buttonStates, id, true);
            }

        },
    },
}
</script>

<style scoped>
    .search_loading {
        display: flex;
        width: 100%;
        justify-self: center;
    }

    .mailing_columnText {
        position: relative;
        z-index: 4;
        display: flex;
        text-overflow: scroll;
        white-space: nowrap;
        overflow: hidden;
        gap: 3px;
        width: 100%;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 22px 15px;
        border-bottom: 1px dashed rgb(161, 161, 161);
        box-sizing: border-box;
    }

    .btn_chevron {
        display: flex;
        width: 22px;
        height: 22px;
        flex-shrink: 0;
    }

    .showAll {
        overflow: visible !important;
        flex-wrap: wrap !important;
        justify-content: flex-start !important;
        align-items: flex-start !important; 
    }

</style>